<div class="container">
  <div class="menu">
    @if (routeLoading) {
      <rxnt-loading-spinner></rxnt-loading-spinner>
    }
    @for (item of menuItems; track item) {
      <a
        (click)="menuClickHandler(item)"
        class="menu-item">{{ item.text }}</a>
    }
  </div>

  <div class="body">
    <router-outlet></router-outlet>
  </div>
</div>
